// removed by extract-text-webpack-plugin
module.exports = {"details":"summary---details---hsOt5","detailsItem":"summary---detailsItem---DMZMC","detailsItemTitle":"summary---detailsItemTitle---3nMO9","containerWidth":"summary---containerWidth---1SSLS","previewTabContainer":"summary---previewTabContainer---1Mh0T","previewTabItem":"summary---previewTabItem---276TP","previewTabItemSelected":"summary---previewTabItemSelected---3jwMX","previewArea":"summary---previewArea---CKJbX","heightForInlay":"summary---heightForInlay---2ooU4","previewAreaWrapper":"summary---previewAreaWrapper---2p6vv"};;
    if (module.hot) {
      var injectCss = function injectCss(prev, href) {
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = href;
        link.onload = function() {
          document.head.removeChild(prev);
        };
        document.head.appendChild(link);
      };
      module.hot.dispose(function() {
        window.__webpack_reload_css__ = true;
      });
      if (window.__webpack_reload_css__) {
        module.hot.__webpack_reload_css__ = false;
        console.log("[HMR] Reloading stylesheets...");
        var prefix = document.location.protocol + '//' + document.location.host;
        document
          .querySelectorAll("link[href][rel=stylesheet]")
          .forEach(function(link) {
            if (!link.href.match(prefix)) return;
            injectCss(link, link.href.split("?")[0] + "?unix=1789047463055");
          });
      }
    }
  